import { z } from "zod";

export const CbomCertificateSchema = z.object({
  c_id: z.number().int().positive().optional(), // AUTO_INCREMENT primary key
  device_id: z.string().max(255).nullable(),
  file_path: z.string().max(255).nullable(),
  serial_number: z.string().max(50).nullable(),
  issue_date: z.string().datetime().nullable(),
  expiry_date: z.string().datetime().nullable(),
  original_signature_algorithm: z.string().max(50).nullable(),
  hashing_algorithm: z.string().max(50).nullable(),
  signature_algorithm: z.string().max(50).nullable(),
  issuer: z.string().nullable(),
  validity_status: z.string().max(50).nullable(),
  time_of_expiry_days: z.number().int().nullable(),
  crl_status: z.string().max(50).nullable(),
  ocsp_status: z.string().max(50).nullable(),
  subject: z.string().nullable(),
  public_key_algorithm: z.string().max(50).nullable(),
  public_key_length: z.number().int().nullable(),
  key_usage: z.string().nullable(),
  extended_key_usage: z.string().nullable(),
  version: z.number().int().nullable(),
  signature_algorithm_qv: z.string().max(50).nullable(),
  public_key_algorithm_qv: z.string().max(50).nullable(),
  cbom_json: z.record(z.any()).nullable(),
});

export type CbomCertificate = z.infer<typeof CbomCertificateSchema>;
